import { classificationsService } from '@/services/classifications.service';

const initialState = () => ({
  classifications: [],
  status: {
    error: null,
    pending: true,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getClassifications({ commit }, filters) {
    commit('GET_CLASSIFICATIONS');
    return classificationsService.getClassifications(filters).then(
      (response) => {
        commit('SUCCESS', response);
      },
      (error) => commit('ERROR', error),
    );
  },
};

const mutations = {
  GET_CLASSIFICATIONS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.classifications = [];
  },
  SUCCESS(state, classifications) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.classifications = classifications;
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  RESET(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const getters = {
  classifications: (state) => state.classifications,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const classifications = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
